import type { NClients, NFiles, NMessage } from '@app/types';

export enum ClientsEndpoints {
  SearchClients = 'SearchClients',
  SearchClientsForRecord = 'SearchClientsForRecord',
  GetClientsFilterData = 'GetClientsFilterData',
  DeleteClientsBySearchId = 'DeleteClientsBySearchId',
  StopImportExcel = 'StopImportExcel',
  FindClientsByPhone = 'FindClientsByPhone',
  GetClientsSearchResult = 'GetClientsSearchResult',
  ExportClientsToExcel = 'ExportClientsToExcel',
  ExportClientsToExcelByIds = 'ExportClientsToExcelByIds',
  DeleteClients = 'DeleteClients',
  GetClientsMessages = 'GetClientsMessages',
  SearchClientsByIntegration = 'SearchClientsByIntegration',
  ImportExcel = 'ImportExcel',
}

export enum ClientsPeriodEnum {
  Today = 'Today',
  Yesterday = 'Yesterday',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  LastThreeMonth = 'LastThreeMonth',
  LastNDays = 'LastNDays',
  Tomorrow = 'Tomorrow',
  NextWeek = 'NextWeek',
  NextMonth = 'NextMonth',
  NextThreeMonth = 'NextThreeMonth',
  NextNDays = 'NextNDays',
  Period = 'Period',
}

export interface ClientsVisitsFilterValue {
  HasRecords: boolean | null;
  Statuses: string[] | null;
  MinCountRecords: number | null;
  MaxCountRecords: number | null;
  DateStart: string | null;
  DateEnd: string | null;
  Period: ClientsPeriodEnum | null;
  OffsetDays: number | null;
  EmployeeIds: number[] | null;
  ServiceCategoryIds: number[] | null;
  ServiceIds: number[] | null;
  MinServicesCost: number | null;
  MaxServicesCost: number | null;
  TagIds: number[] | null;
}

export interface ClientsFilterValue {
  Gender: Array<string | null> | null;
  TagIds: number[] | null;
  MinServicesCost: number | null;
  MaxServicesCost: number | null;
  IsReceivedSMS: boolean | null;
  DateStart: string | null;
  DateEnd: string | null;
  Birthday: ClientsPeriodEnum | null;
  OffsetDays: number | null;
  MinAge: number | null;
  MaxAge: number | null;
  BalanceS: number | null;
  BalanceE: number | null;
  HasOpenTasks: boolean | null;
}

export interface ClientsSalesFilterValue {
  ProductIds: number[];
}

export interface ClientsVisitsFilter {
  IsInclude: boolean;
  Values: ClientsVisitsFilterValue[];
}

export interface ClientsClientsFilter {
  IsInclude: boolean;
  Values: ClientsFilterValue[];
}

export interface ClientsSalesFilter {
  IsInclude: boolean;
  Values: ClientsSalesFilterValue[];
}

export interface ClientsClientFilter {
  VisitsFilter: ClientsVisitsFilter[];
  ClientsFilter: ClientsClientsFilter[];
  SalesFilter: ClientsSalesFilter[];
}

export interface SearchClientsPayload {
  SearchTerm: string | null;
  ClientsPerPage: number;
  Filters: ClientsClientFilter[];
}

export interface SearchClientsRequest {
  ActiveBranchId: number | null;
  data: SearchClientsPayload;
}

export interface SearchClientsForRecordRequest {
  searchTerm: string;
  take?: number;
  ActiveBranchId: number | null;
}

export interface ModelClientForRecord {
  Id: number;
  NameFirst: string | null;
  NameLast: string | null;
  NameMiddle: string | null;
  Phone1: string | null;
  Phone2: string | null;
  IsPhoneVerified: boolean;
  Gender: string | null;
  Age: number | null;
}

export interface GetClientsFilterDataRequest {
  ActiveBranchId: number | null;
}

export interface DeleteClientsBySearchIdRequest {
  ActiveBranchId: number | null;
  searchId: number;
}

export interface StopImportExcelRequest {
  ActiveBranchId: number | null;
}

export interface FindClientsByPhoneRequest {
  branchId: number;
  phone1: string;
  phone2: string;
  ActiveBranchId: number | null;
}

export type SearchClientsResponse = NClients.ModelClientSearchResult;
export type SearchClientsForRecordResponse = ModelClientForRecord[];
export type GetClientsFilterDataResponse = NClients.ModelClientsFilterData;
export type DeleteClientsBySearchIdResponse = void;
export type StopImportExcelResponse = void;
export type FindClientsByPhoneResponse = NClients.ModelClientLite[];

export interface GetClientsSearchResultRequest {
  searchId: number;
  page: number;
  rowsPerPage: number;
  ActiveBranchId: number | null;
}

export interface ExportClientsToExcelRequest {
  searchId: number;
  ActiveBranchId: number | null;
}

export interface ExportClientsToExcelByIdsRequest {
  ActiveBranchId: number | null;
  data: number[];
}

export interface DeleteClientsRequest {
  ActiveBranchId: number | null;
  data: number[];
}

export interface GetClientsMessagesRequest {
  dateS: string;
  dateE: string;
  ActiveBranchId: number | null;
}

export interface SearchClientsByIntegrationRequest {
  integrationId: number;
  userName: string;
  clientName: string | null;
  ActiveBranchId: number | null;
}

export interface ImportExcelRequest {
  extension: string;
  ActiveBranchId: number | null;
  data: string;
}

export type GetClientsSearchResultResponse = NClients.ModelClientSearchResult;
export type ExportClientsToExcelResponse = NFiles.ModelFile;
export type ExportClientsToExcelByIdsResponse = NFiles.ModelFile;
export type DeleteClientsResponse = void;
export type GetClientsMessagesResponse = NMessage.ModelClientMessage[];
export type SearchClientsByIntegrationResponse = NClients.ModelClientLite[];
export type ImportExcelResponse = void;
